import I18n from 'I18n';
export const TranslationStrings = {
  getButtonLabel: () => I18n.text('cmsf-branding.buttonLabel'),
  getReportAbuseLinkText: () => I18n.text('cmsf-branding.dropdown.reportAbuse'),
  getCmsPurchaseLinkText: () => I18n.text('cmsf-branding.dropdown.getCms')
};